const learn = {
    namespaced : true,
    state : {
        activeID: null,
        menuList: [],
        reload: true,
        showMenu: false,
        resize: false
    },
    mutations : {
        setActiveID(state, payload) {
            state.activeID = payload
        },
        setMenu(state, payload) {
            state.menuList = payload
        },
        setReload(state, payload) {
            state.reload = payload
        },
        setResize(state, payload) {
            state.resize = payload
        },
        setShowMenu(state, payload) {
            state.showMenu = payload
        }
    },
    getters : {
        getActiveID(state) {
            return state.activeID
        },
        getMenu(state) {
            return state.menuList
        },
        getReload(state) {
            return state.reload
        },
        getResize(state) {
            return state.resize
        },
        getShowMenu(state) {
            return state.showMenu
        }
    }
};

export default learn;


// WEBPACK FOOTER //
// ./src/stores/modules/learn.js